import { render } from "./file-card.vue.js?vue&type=template&id=5f5e92a9!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./file-card.vue?vue&type=template&id=5f5e92a9"
import script from "./file-card.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./file-card.vue?vue&type=script&lang=js"
export * from "./file-card.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./file-card.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__